'use client'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { HeaderDesktop } from './header-desktop/HeaderDesktop'
import { HeaderMobile } from './header-mobile/HeaderMobile'
import styles from './Header.module.scss'
import { useErrorHandling } from '@/tools/o11y/client'
import { useIntersectionDetection } from '@/tools/ui/components/header/ui/use-intersection-detection'

export enum HeaderColorEnum {
  brand = 'brand',
  background = 'background',
}
export type HeaderColorType = keyof typeof HeaderColorEnum

type Props = {
  color?: HeaderColorType
  hasLocationBanner?: boolean
  hasScrollLocationDrawer?: boolean
  shouldShowAddress?: boolean
  shouldShowSearch?: boolean
  searchType?: string
}
export const Header = ({
  color = 'brand',
  shouldShowAddress = false,
  shouldShowSearch = false,
  hasLocationBanner = false,
  hasScrollLocationDrawer = false,
  searchType = 'GLOBAL',
}: Props) => {
  const { withErrorTracking, execWithErrorTracking } = useErrorHandling()

  const [isIntersecting, setIsIntersecting] = useState(false)
  const isDesktopHeaderColliding = useIntersectionDetection(
    'header-desktop',
    'hero-container-input'
  )
  const isMobileHeaderColliding = useIntersectionDetection('header-mobile', 'hero-container-input')
  const handleScroll = withErrorTracking(() => {
    setIsIntersecting(isDesktopHeaderColliding || isMobileHeaderColliding)
  })

  useEffect(() => {
    execWithErrorTracking(async () => {
      window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktopHeaderColliding, isMobileHeaderColliding, execWithErrorTracking])

  return (
    <header className={classNames(styles.header, styles[`${color}ColorHeader`])}>
      <HeaderDesktop
        className={styles.desktopVisibility}
        color={color}
        hasLocationBanner={hasLocationBanner}
        hasScrollLocationDrawer={hasScrollLocationDrawer}
        isIntersecting={isIntersecting}
        searchType={searchType}
        shouldShowAddress={shouldShowAddress}
        shouldShowSearch={shouldShowSearch}
      />
      <HeaderMobile
        className={styles.mobileVisibility}
        color={color}
        isIntersecting={isIntersecting}
        searchType={searchType}
        shouldShowAddress={shouldShowAddress}
        shouldShowSearch={shouldShowSearch}
      />
    </header>
  )
}
